// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"191":"d963eb88","488":"b9bacd90","623":"8c4538a8","910":"9bab7ab5"}[chunkId] + ".chunk.css";
};